import React, { forwardRef, useImperativeHandle, useRef, useMemo } from 'react';
import { GenericSettingsPane, GenericSettingsPaneHandle } from './GenericSettingsPane';
import { PaneHandle, PaneProps } from '../accountParameter.types';
import { useStoreState } from '../../../../models/hooks';
import { useTranslation } from 'react-i18next';

export const OfferPane = forwardRef<PaneHandle, PaneProps>(({ onSave, setDirty, showActions }, ref) => {
  const genericPaneRef = useRef<GenericSettingsPaneHandle>(null);
  const account = useStoreState((state) => state.app.accounts);
  const { t } = useTranslation('accountParameter');

  useImperativeHandle(ref, () => ({
    save: () => genericPaneRef.current?.save(),
    reset: () => genericPaneRef.current?.reset(),
  }));

  const memoizedItems = useMemo(
    () => [
      {
        key: 'candidateReofferEnabled',
        label: t('offerPane.candidateReofferEnabled'),
        description: t('offerPane.candidateReofferEnabledDescription'),
        value: account?.configuration?.candidateReofferEnabled ?? false,
        type: 'boolean' as const,
      },
      {
        key: 'offerConditionsEnabled',
        label: t('offerPane.offerConditionsEnabled'),
        description: t('offerPane.offerConditionsEnabledDescription'),
        value: account?.configuration?.offerConditionsEnabled ?? false,
        type: 'boolean' as const,
      },
    ],
    [account, t],
  );

  return (
    <GenericSettingsPane
      ref={genericPaneRef}
      onSave={onSave}
      setDirty={setDirty}
      showInlineActions={showActions}
      items={memoizedItems}
    />
  );
});
